import { render, staticRenderFns } from "./Alarmas.vue?vue&type=template&id=a22bc6e2&scoped=true&"
import script from "./Alarmas.vue?vue&type=script&lang=js&"
export * from "./Alarmas.vue?vue&type=script&lang=js&"
import style0 from "./Alarmas.vue?vue&type=style&index=0&id=a22bc6e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22bc6e2",
  null
  
)

export default component.exports